import { render, staticRenderFns } from "./nodeal.vue?vue&type=template&id=2896f768&scoped=true&"
import script from "./nodeal.vue?vue&type=script&lang=js&"
export * from "./nodeal.vue?vue&type=script&lang=js&"
import style0 from "./nodeal.vue?vue&type=style&index=0&id=2896f768&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896f768",
  null
  
)

export default component.exports